export default __webpack_public_path__ + "static/media/returnway.f437e904.svg";